export const OptionsInterval: {name: string, value: number}[] = [
  {name: 'Сегодня', value: 1},
  {name: 'За 3 дня', value: 3},
  {name: 'За неделю', value: 7},
  {name: 'За 10 дней', value: 10},
  {name: 'За месяц', value: 30},
  {name: 'За весь период', value: 0},
];
